var React = require('react');

function Store (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.5418 10.3C18.8116 10.3 23.0836 8.88968 23.0836 7.14999C23.0836 5.4103 18.8116 4 13.5418 4C8.272 4 4 5.4103 4 7.14999C4 8.88968 8.272 10.3 13.5418 10.3Z","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M23.0836 14.4995C23.0836 16.2427 18.8428 17.6498 13.5418 17.6498C8.24079 17.6498 4 16.2427 4 14.4995","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M4 7.1499V21.85C4 23.593 8.24079 25 13.5418 25C18.8428 25 23.0836 23.593 23.0836 21.85V7.1499","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Store.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Store;

Store.default = Store;
